import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/_services/authentication.service';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss']
})
export class LoginFormComponent implements OnInit {

  profil : boolean = false;
  profilType : string  = 'talent' ;
  constructor(
    private AuthService : AuthenticationService,
    private router : Router
  ) { }

  ngOnInit(): void {
  }

  showProfil(){
    this.profil = !this.profil;
    if (this.profil == true) {
        this.profilType = 'entrepise';
    }
    else{
      this.profilType = 'talent';
    }
  }

  login(){
    this.AuthService.saveToken(this.profilType);
    localStorage.setItem('menuItem', 'profil');
    this.router.navigate(['/profil/'])
  }
}
